import Cookies from 'js-cookie'
import { supabase } from './supabase/client'
import { jwtDecode } from 'jwt-decode'
import { getCustomer } from '@/utils/supabase/auth'

// Cookie names
const ACCESS_TOKEN = 'access-token'
const REFRESH_TOKEN = 'refresh-token'

// Cookie options
const cookieOptions = {
  expires: 7, // 7 days
  secure: true,
  sameSite: 'strict'
}

export const auth = {
  // Set session data in cookies
  setSession(session) {
    if (session) {
      Cookies.set(ACCESS_TOKEN, session.access_token, cookieOptions)
      if (session.refresh_token) {
        Cookies.set(REFRESH_TOKEN, session.refresh_token, cookieOptions)
        const jwt = jwtDecode(session.access_token)
        const userRole = jwt.user_role
      }
    }
  },

  // Clear session data from cookies
  clearSession() {
    Cookies.remove(ACCESS_TOKEN)
    Cookies.remove(REFRESH_TOKEN)
  },

  // Get session data from cookies
  getSession() {
    const access_token = Cookies.get(ACCESS_TOKEN)
    const refresh_token = Cookies.get(REFRESH_TOKEN)
    return access_token ? { access_token, refresh_token } : null
  },

  // Get current user from session
  async getUser() {
    const session = this.getSession()
    if (session?.access_token) {
      const {
        data: { user }
      } = await supabase.auth.getUser(session.access_token)
      return user
    }
    return null
  },

  async signIn(email, password) {
    try {
      const { data, error } = await supabase.auth.signInWithPassword({
        email,
        password
      })

      if (error) throw error

      if (data?.session) {
        this.setSession(data.session)
      }

      return { data, error: null }
    } catch (error) {
      return { data: null, error }
    }
  },

  async signOut() {
    try {
      const { error } = await supabase.auth.signOut({ scope: 'local' })
      if (error) throw error

      this.clearSession()

      return { error: null }
    } catch (error) {
      return { error }
    }
  },

  async refreshSession() {
    const refreshToken = Cookies.get(REFRESH_TOKEN)
    if (!refreshToken) return { data: null, error: new Error('No refresh token') }

    try {
      const { data, error } = await supabase.auth.refreshSession({
        refresh_token: refreshToken
      })

      if (error) throw error

      if (data?.session) {
        this.setSession(data.session)
      }

      return { data, error: null }
    } catch (error) {
      return { data: null, error }
    }
  }
}
